import moment from 'moment-timezone';
import { useDispatch } from "react-redux";
import { fromRruleString } from "../../helpers/rrule";
import { openEventNotificationModel, openScheduleEventSendNotificationModel, deleteScheduledNotification, openEditScheduledNotificationModel } from "../../store/slices/eventSlice";
import SweetAlert from "../SweetAlert/SweetAlert";
import Swal from "sweetalert2";



const ScheduledNotification = ({ notification }) => {
    const dispatch = useDispatch();

    const handleDelete = (id) => {

        SweetAlert({
            title: "Delete",
            text: `Do you want to delete the scheduled notification`,
            confirmAction: async () => {
                Swal.showLoading();
                await dispatch(deleteScheduledNotification(id)).unwrap();
            },
        });
    };


    const renderSchedule = (attributes) => {

        const getDuration = (value) => {
            if (value == null) { return ''; }
            if (value <= 0) { return ''; }
            const hours = Math.floor(value / 60);
            const minutes = value % 60;
            let hour;
            if (hours === 0) {
                hour = '';
            } else if (hours === 1) {
                hour = `${hours} hr `;
            } else {
                hour = `${hours} hrs `;
            }
            const min = (minutes > 0) ? `${minutes} mins` : '';
            return (hour + min).trim();
        }

        const rules = fromRruleString(attributes?.rrule);
        if (!rules) return false
        const timezone = attributes?.tz || 'UTC';
        let startTime, startTimeDaily, endTime;
        
        if (attributes.startDate) {
            const dateWithoutTz = attributes.startDate.replace(/[TZ].*$/, '').replace(/[+\-]\d{2}:\d{2}$/, '');
            const baseMoment = moment.tz(dateWithoutTz, timezone);
            startTime = baseMoment.format('Y-MM-DD hh:mma');
            startTimeDaily = baseMoment.format('hh:mma');
            endTime = baseMoment.add(attributes.duration, 'minutes').format('hh:mma');
        }


        if (rules.recurring) {
            if (rules.recurringType === 'daily') {
                return (
                    <>
                        <p className="f-11 mb-0">Schedule</p>
                        <p className="f-12"><strong>Daily {startTimeDaily} to {endTime} ({getDuration(attributes.duration)})</strong></p>
                    </>
                );
            }
            if (rules.recurringType === 'weekly') {
                return (
                    <>
                        <p className="f-11 mb-0">Schedule</p>
                        <p className="f-12"><strong>Weekly ({rules.days ? rules.days.join(', ') : 'none'}) {startTimeDaily} to {endTime} ({getDuration(attributes.duration)})</strong></p>
                    </>
                );
            }
        }
        if (!rules.recurring) {
            return (
                <>
                    <p className="f-11 mb-0">Schedule</p>
                    <p className="f-12"><strong>{startTime} to {endTime} ({getDuration(attributes.duration)})</strong></p>
                </>

            );
        }
        return null;
    }

    const rendorTime = (time, date, timezone) => {
        let startTime;
        
        if (timezone && date) {
            const dateWithoutTz = date.replace(/[TZ].*$/, '').replace(/[+\-]\d{2}:\d{2}$/, '');
            startTime = moment.tz(dateWithoutTz, timezone).format('Y-MM-DD');
        } else {
            startTime = moment(date).format('Y-MM-DD');
        }
        
        const startTimeDaily = time;

        return (
            <>
                <p className="f-11 mb-0">Scheduled Time</p>
                <p className="f-12">
                    <strong>{`${startTime} at ${startTimeDaily}`}</strong>
                </p>
            </>
        )
    }




    return (
        <div className="poll-cell border">
            <div className="pb-2">
                <div className="top-section">
                    <div className="header-section">
                        <span className="question-heading">{notification.subject}</span>
                        <span className="status">{notification.message}</span>
                    </div>
                </div>

                <div className="answer-section">
                    <div style={{ fontSize: '12px' }}>

                        {notification.notification_eventId && (
                            <>
                                {renderSchedule(notification)}

                                {notification.hosts?.length > 0 && (
                                    <>
                                        <p className="f-11 mb-0">DJs</p>
                                        <p className="f-12">
                                            <strong>{notification.hosts.join(', ')}</strong>
                                        </p>
                                    </>
                                )}

                                {notification.tags?.length > 0 && (
                                    <>
                                        <p className="f-11 mb-0">Tags</p>
                                        <p className="f-12">
                                            <strong>{notification.tags.join(', ')}</strong>
                                        </p>
                                    </>
                                )}
                            </>
                        )}

                        {rendorTime(notification.time, notification.date, notification.tz)}


                    </div>
                </div>
            </div>
            <div className="footer-section">
                <div className="d-flex justify-content-end">
                    <div className="px-1">
                        <button
                            onClick={() => {
                                dispatch(openEditScheduledNotificationModel(notification))
                            }}
                            className="btn btn-dark f-11 px-4"
                        >
                            Edit
                        </button>
                    </div>
                    <div className="px-1">
                        <button
                            className="btn btn-outline-secondary f-11 px-4"
                            onClick={() => {
                                handleDelete(notification.notification_id)
                            }}
                        >
                            Delete
                        </button>
                    </div>

                </div>
            </div>

        </div>
    )
};

export default ScheduledNotification;